import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "ww-numberpad",
  role: "group",
  "aria-label": "Ziffernblock"
}
const _hoisted_2 = {
  class: "ww-numberpad__display",
  "aria-label": "Eingabe"
}
const _hoisted_3 = { class: "ww-numberpad__value" }
const _hoisted_4 = { class: "ww-numberpad__grid" }
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = { class: "ww-numberpad__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.currentValue), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (k) => {
        return (_openBlock(), _createElementBlock("button", {
          key: k.id,
          class: _normalizeClass(["ww-numberpad__key", [
          k.kind ? `is-${k.kind}` : '',
          k.disabled ? 'is-disabled' : ''
        ]]),
          type: "button",
          disabled: k.disabled,
          onClick: ($event: any) => (_ctx.onKey(k))
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(k.label), 1)
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}